export default __webpack_public_path__ + "static/media/696.9305d016.png";